import { render, staticRenderFns } from "./Public-View-Doc-File.vue?vue&type=template&id=09e5ce9c&scoped=true&"
import script from "./Public-View-Doc-File.vue?vue&type=script&lang=js&"
export * from "./Public-View-Doc-File.vue?vue&type=script&lang=js&"
import style0 from "./Public-View-Doc-File.vue?vue&type=style&index=0&id=09e5ce9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e5ce9c",
  null
  
)

export default component.exports